import React, { Component } from 'react'
import { observer } from 'mobx-react'
import List from './List'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import { getMerchantInfo } from '@util'
import InitRouterView from '@common/InitRouterView'
@InitRouterView()
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(this.props.location.query.type || '2')
    this.store.updateMerchantInfo(getMerchantInfo()) //获取当前用户信息
  }

  render() {
    return (
      <HeaderView {...this.props.viewData} title="案例审核">
        <List store={this.store} />
      </HeaderView>
    )
  }
}
